import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Brand } from "@/components/Brand";

export default function NotFound() {
    return (
        <div className="flex min-h-screen flex-col bg-background">
            <header className="border-b border-line px-6 py-4">
                <Brand />
            </header>
            <div className="flex flex-1 flex-col items-center justify-center px-6 text-center">
                <p className="tnum text-[64px] font-bold tracking-tight text-terracotta">404</p>
                <h1 className="mt-2 text-[24px] font-bold tracking-tight text-ink">Aquí no hay nada</h1>
                <p className="mt-2 max-w-sm text-[16px] leading-[1.6] text-subtle">
                    La página que buscas no existe o se ha movido. Volvamos a un sitio conocido.
                </p>
                <Button asChild className="mt-6">
                    <Link to="/">Ir al inicio</Link>
                </Button>
            </div>
        </div>
    );
}
